import type { Collection } from 'state/utils/types';

export type CpOrderStatus = 'NOT_READY' | 'READY' | 'ORDER_PENDING' | 'ORDER_PLACED' | 'ORDER_FAILED';

export type OrderState = {
  status?: 'PENDING' | 'DONE' | 'REJECTED';
  errorMessage?: string;
  id?: string;
  execTime?: string;
  tradeDate?: string;
  cobDate?: string;
  valuationDate?: string;
  settlementDate?: string;
  validations?: OrderValidation[];
  timeout?: number;
  isTimeout?: boolean;
};

export type OrderValidation = {
  level: string;
  message: string;
};

export type OrderStateMap = Collection<OrderState>;

export const initialOrderState: OrderState = {};

export const initialOrderMap = {};
